import * as feEvents from '@dazn/fe-events';

// Correctly declare the module with the appropriate type definitions
declare module '@dazn/fe-events' {
    export function triggerElementClickEvent(params: {
        element: {
            type: string;
            itemType: string;
            itemId: string;
            itemName: string;
            source?: string;
        };
    }): void;
}

// Define the types of element click events
const elementClickEventTypes = {
    BODY: 'body',
    FLOAT: 'float',
    FOOTER: 'footer',
    HEADER: 'header',
    NAVIGATION: 'navigation',
    SIDEBAR: 'sidebar',
    STICKY: 'sticky'
} as const;

// Type derived from the elementClickEventTypes object
type ElementClickEventType =
    (typeof elementClickEventTypes)[keyof typeof elementClickEventTypes];

// Define the types of sources for element click events
const elementClickEventSourceTypes = {
    LINK_URL: 'link url',
    RESOURCE_STRING_KEY: 'resource string key',
    CONTENT_FUL: 'contentful',
    DEFAULT: ''
} as const;

// Type derived from the elementClickEventSourceTypes object
type ElementClickEventSourceType =
    (typeof elementClickEventSourceTypes)[keyof typeof elementClickEventSourceTypes];

// Interface for the properties of the triggerElementClickEvent function
interface TriggerElementClickEventProps {
    type: ElementClickEventType;
    itemId: string;
    itemName: string;
    source?: ElementClickEventSourceType;
}

// Function to trigger an element click event
const triggerElementClickEvent = ({
    type,
    itemId,
    itemName,
    source = ''
}: TriggerElementClickEventProps): void => {
    feEvents.triggerElementClickEvent({
        element: {
            type,
            itemType: 'element',
            itemId,
            itemName,
            ...(source ? {source} : {})
        }
    });
};

export {
    triggerElementClickEvent,
    elementClickEventTypes,
    elementClickEventSourceTypes
};
